import { MovieClip } from '@play-co/timestep-core/ui';
import { Container } from '../../../odie';

import { MushroomBlockProps } from '../../defs/block';
import { blockPositionView } from '../../util/blockTools';
import { getMatch2AssetPath } from '../../util/assets';
import { AssetDescription } from '@play-co/timestep-core';

// constants
//-----------------------------------------------------------------------------
const manifest = () => ({
  moveclip: {
    url: getMatch2AssetPath('blocks/mushroom'),
    loadMethod: MovieClip.animationLoader,
  },
});

/*
    mushroom block view
*/
export class MushroomBlockView extends Container {
  private _animation: MovieClip;
  // init
  //-------------------------------------------------------------------------
  constructor(props: MushroomBlockProps) {
    // create base view
    super();

    this._animation = new MovieClip({
      superview: this.view,
      url: manifest().moveclip.url,
      scale: 0.86,
    });
    this._animation.play('mushroom_idle', null, true);

    // position
    blockPositionView(this, props);
    this.y += 5;
  }

  public static assets(): (string | AssetDescription<any>)[] {
    return Object.values(manifest());
  }

  public async animateIn() {
    await this._animation.playAsync('mushroom_spawn');
    this._animation.play('mushroom_idle', null, true);
  }
}
